import { Avatar, Box, Grid, IconButton, Typography } from "@mui/material";
// import avatarTest from '../images/others/NoAvatar.png';
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EditNoteIcon from '@mui/icons-material/EditNote';
import StarIcon from '@mui/icons-material/Star';
import { useSelector } from "react-redux";
import { loginSelector } from "store/slices/loginSlice";
import { useEffect, useState } from "react";
import { get } from "api/apiBridges/httpBridge";
import UserAvatar from "../components/EIComponents/UserAvatar";
import Loading from "./Load";

// Компонент для шапки в кабинете клиента
export default function SubHeaderClient(params) {

    const { user_id, company_id} = useSelector(
        loginSelector
    );

    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState({
        api_key: "",
        data: "",
        deleted: undefined,
        email: "",  
        fio: "",
        ip_id: "",
        manager_id: "1",
        mobile_number: "",
        status: "",
        photo: undefined
    })
    const [manager, setManager] = useState({
        name: "Не указано",
        mobile_number: "Не указано",
    })

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
            const responseData = await get('Clients/get', {cid:user_id});
            console.log('RESPONSE CLIENT', responseData)
            if (responseData?.message) {
                let photo = undefined
                if (responseData.message.data) {
                    let clidata = JSON.parse(responseData.message.data)
                    photo = clidata.photo 
                }
                let obj = {
                    api_key: responseData.message.api_key || undefined,
                    data: responseData.message.data || undefined,
                    deleted: responseData.message.deleted || undefined,
                    email: responseData.message.email || "Не указано",  
                    fio: responseData.message.fio || "Не указано",
                    ip_id: responseData.message.ip_id || undefined,
                    manager_id: responseData.message.manager_id || undefined,
                    mobile_number: responseData.message.mobile_number || "Не указано",
                    status: responseData.message.status || "Не указано",
                    photo
                }
                setUser(obj)
                if (obj.manager_id) {
                    const responseDataManager = await get('Admins/get', {mid: obj.manager_id});
                    console.log('MANAGER', responseDataManager)
                    if (responseDataManager?.message) {
                        let mobj = {
                            name: responseDataManager.message.name || "Не указано",
                            mobile_number: responseDataManager.message.mobile_number || "Не указано"
                        }
                        setManager(mobj)
                    }
                }
            }
            } catch (err) {
            } finally {
            setLoading(false);
            }
        };

        fetchData();
    }, [user_id]); 

    if (loading) {
        return <Loading></Loading>
    }

    return (
        <div style={{width: "96%", display: "flex", flexDirection: "row", alignItems: "stretch", margin: "5% 2% 1% 2%", borderRadius: "10px", backgroundColor: "rgba(255, 255, 255, 0.0)", overflow: "hidden"}}>
            <div style={{
                width: "35%",
                backgroundColor: '#F5F9FA',//'rgba(255, 255, 255, 0.8)',
                display: "flex",
                flexDirection: "column",
                padding: "1%",
            }}>
                <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginBottom: "5%"}}>
                    <UserAvatar src={user.photo} userData={user} user_id={user_id} size={90}/>
                    <div style={{display: "flex", flexDirection: "column", marginLeft: "4%"}}>
                        <Typography variant="h2" style={{ fontWeight: 'bold' }}>{user.fio}</Typography>
                        <Typography variant="h2" style={{ fontWeight: 'normal', color: 'gray' }}>#{user_id}</Typography>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginBottom: "8px"}}>
                    <Typography variant="h3" style={{ fontWeight: 'normal', color: 'gray' }}>e-mail:</Typography>
                    <Typography variant="h3" style={{ fontWeight: 'normal'}}>{user.email}</Typography>
                </div>
                <div style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginBottom: "8px"}}>
                    <Typography variant="h3" style={{ fontWeight: 'normal', color: 'gray' }}>Телефон:</Typography>
                    <Typography variant="h3" style={{ fontWeight: 'normal'}}>{user.mobile_number}</Typography>
                </div>
                <div style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginBottom: "8px"}}>
                    <Typography variant="h3" style={{ fontWeight: 'normal', color: 'gray' }}>Персональный статус:</Typography>
                    <Typography variant="h3" style={{ fontWeight: 'normal'}}>{user.status}</Typography>
                </div>
                <div style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between"}}>
                    <Typography variant="h3" style={{ fontWeight: 'normal', color: 'gray' }}>Телефон менеджера:</Typography>
                    <Typography variant="h3" style={{ fontWeight: 'normal'}}>{manager.mobile_number}</Typography>
                </div>
            </div>
            <div style={{
                width: "65%",
                backgroundColor: 'rgba(255, 255, 255, 0.5)',
            }}>
                <div style={{width: "100%", height: "100%", display: 'flex', alignItems: "center", justifyContent: "center"}}>
                    Уже скоро)
                </div>
            </div>
        </div>
    )
}